import type { TFunction } from 'i18next';
import { ThemeToggle } from '../ThemeToggle';
import { BookingAccountMenu } from './BookingAccountMenu';
import { CustomerActivityBellButton, CustomerActivityDrawer } from '../CustomerActivityDrawer';
import { BookingLanguageControl } from './BookingLanguageControl';
import { ChromeActions } from '../../../../../packages/ui/src';

export type BookingChromeActionsProps = {
  language: string;
  onLanguageChange: (code: string) => void;
  t: TFunction;
  tenantId: string;
  emailForBookings: string | null;
  telegramId: string | null;
  whatsappId?: string | null;
  onNavigateBookings: () => void;
  onMyBundles?: () => void;
  activityOpen: boolean;
  onActivityOpen: () => void;
  onActivityClose: () => void;
  activityUnreadCount: number;
  onActivityUnreadCount?: (n: number) => void;
  showSignIn: boolean;
  onSignIn: () => void;
  showSignOut: boolean;
  onSignOut?: () => void | Promise<void>;
  onOpenProfile: () => void;
  /** Mis reservas / pantallas compactas: idioma solo en menú cuenta. */
  embedLanguageInAccountMenu?: boolean;
};

export function BookingChromeActions({
  language,
  onLanguageChange,
  t,
  tenantId,
  emailForBookings,
  telegramId,
  whatsappId,
  onNavigateBookings,
  onMyBundles,
  activityOpen,
  onActivityOpen,
  onActivityClose,
  activityUnreadCount,
  onActivityUnreadCount,
  showSignIn,
  onSignIn,
  showSignOut,
  onSignOut,
  onOpenProfile,
  embedLanguageInAccountMenu,
}: BookingChromeActionsProps) {
  return (
    <>
      <ChromeActions
        secondary={[
          <ThemeToggle key="theme" />,
          <CustomerActivityBellButton
            key="activity"
            onClick={onActivityOpen}
            unreadCount={activityUnreadCount}
            label={t('booking.activity_aria')}
          />,
          <BookingAccountMenu
            key="account"
            onMyBookings={onNavigateBookings}
            onMyBundles={onMyBundles}
            onOpenActivity={onActivityOpen}
            onOpenProfile={onOpenProfile}
            showSignIn={showSignIn}
            onSignIn={onSignIn}
            showSignOut={showSignOut}
            onSignOut={onSignOut}
            languagePicker={
              embedLanguageInAccountMenu
                ? { language, languages: ['es', 'en', 'fr', 'de', 'pt'], onLanguageChange: onLanguageChange }
                : undefined
            }
          />,
          !embedLanguageInAccountMenu ? (
            <BookingLanguageControl
              key="language"
              language={language}
              onLanguageChange={onLanguageChange}
              t={t}
              languages={['es', 'en', 'fr', 'de', 'pt']}
            />
          ) : (
            <></>
          ),
        ]}
        onOpenActivityDrawer={onActivityOpen}
      />
      <CustomerActivityDrawer
        tenantId={tenantId}
        email={emailForBookings}
        telegramId={telegramId}
        whatsappId={whatsappId}
        open={activityOpen}
        onClose={onActivityClose}
        onUnreadCount={onActivityUnreadCount}
      />
    </>
  );
}
